import styled from "styled-components";
import { motion } from "framer-motion";
import google from "../img/google.svg";
import apple from "../img/apple-badge.svg";

const Mobile = () => {
  return (
    <MobileContainer id="More Services">
      <h2>Download the App Today</h2>

      <p>
        No matter what you’re saving towards, we equip you with tools to make it
        easy to set up and track your progress. Download the app toady and start
        saving in minutes.
      </p>

      <div className="icon-holder">
        <img className="google-btn" src={google} alt="play-store" />
        <img className="apple-btn" src={apple} alt="app-store" />
      </div>
    </MobileContainer>
  );
};

export default Mobile;

const MobileContainer = styled(motion.div)`
  min-height: 50vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  background: #f8f1f1;
  padding: 0rem 20rem;

  @media (min-width: 1600px) {
    min-height: 25rem;
  }

  @media (max-width: 1100px) {
    padding: 0rem 10rem;
  }

  @media (max-width: 700px) {
    padding: 0rem 5rem;
  }

  @media (max-width: 450px) {
    padding: 2rem 2rem;
  }

  p,
  h2 {
    white-space: normal;
    font-family: "Roboto", sans-serif;
  }

  p {
    line-height: 1.5rem;
  }

  p,
  h2,
  div {
    padding: 1rem 0rem;
  }

  .icon-holder {
    display: flex;
  }

  img {
    width: 10rem;
    cursor: pointer;
    padding: 0.5rem;

    &:hover {
      filter: brightness(80%);
    }

    @media (max-width: 450px) {
      width: 8rem;
    }
  }
  .google-btn {
    width: 10.7rem;

    @media (max-width: 450px) {
      width: 8.3rem;
    }
  }
`;
